import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { getQueryKeys } from '../queries/queryKeys';

const fetchStages = ({ stageId, hideErrorMessage }) => {
  return request.get(
    'FlatsGrid/stage_address_life_cycle_by_stage_id',
    { stageId },
    'Не удалось загрузить стадии помещения',
    'Error',
    undefined,
    undefined,
    undefined,
    hideErrorMessage
  );
};

const useStagesByStageQuery = (
  { stageId, hideErrorMessage = true },
  options
) => {
  return useQuery(
    getQueryKeys.stagesLifeCirleByStage(stageId),
    () => fetchStages({ stageId, hideErrorMessage }),
    { enabled: Boolean(stageId), staleTime: Infinity, ...options }
  );
};

export default useStagesByStageQuery;
